import { Navigate } from "react-router-dom";
import useAuthAccess from "../hooks/useAuthAccess";

const PublicOnlyRoute = ({ children }) => {
  const { loading, isAuthenticated, role, defaultRoute } = useAuthAccess();

  if (loading) {
    return (
      <div className="flex min-h-screen items-center justify-center bg-[#fffaf6]">
        <div className="h-14 w-14 animate-spin rounded-full border-4 border-[#c90243] border-t-transparent" />
      </div>
    );
  }

  if (isAuthenticated && role) {
    return <Navigate to={defaultRoute} replace />;
  }

  return children;
};

export default PublicOnlyRoute;
